(function () {
  if (window.__mdsCartDrawerControllerBound) return;
  window.__mdsCartDrawerControllerBound = true;
  document.documentElement.setAttribute('data-mds-cart-drawer-controller', 'loading');

  function cartAddUrl() {
    return window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function closeMobileNav() {
    if (window.mdsMobileNav && window.mdsMobileNav.isOpen()) {
      window.mdsMobileNav.close();
    }
  }

  function openDrawer(cart, source) {
    if (!cart) return;
    closeMobileNav();

    if (typeof cart.open === 'function') {
      cart.open(source);
      return;
    }

    cart.classList.add('animate', 'active');
    cart.removeAttribute('aria-hidden');
    document.body.classList.add('overflow-hidden');
  }

  function renderDrawer(cart, response, source) {
    if (!cart) return;

    function render() {
      if (typeof cart.renderContents !== 'function') return false;
      cart.renderContents(response);
      window.setTimeout(function () {
        openDrawer(cart, source);
      }, 30);
      return true;
    }

    if (render()) return;

    openDrawer(cart, source);
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(render);
    }
  }

  function normalizedPath(url) {
    return new URL(url, window.location.href).pathname.replace(/\/+$/, '').replace(/\.js$/, '');
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action');
    if (!action) return false;

    try {
      return normalizedPath(action) === normalizedPath(cartAddUrl());
    } catch (error) {
      return false;
    }
  }

  function setSubmitting(form, submitter, submitting) {
    form.dataset.mdsSubmitting = submitting ? 'true' : 'false';
    if (!submitter) return;

    if (submitting) {
      submitter.dataset.mdsWasDisabled = submitter.disabled ? 'true' : 'false';
      submitter.disabled = true;
      submitter.setAttribute('aria-disabled', 'true');
      submitter.setAttribute('aria-busy', 'true');
      return;
    }

    if (submitter.dataset.mdsWasDisabled !== 'true') submitter.disabled = false;
    delete submitter.dataset.mdsWasDisabled;
    submitter.removeAttribute('aria-disabled');
    submitter.removeAttribute('aria-busy');
  }

  function requestSections(cart, formData) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return;

    formData.set(
      'sections',
      cart.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',')
    );
    formData.set('sections_url', window.location.pathname);
  }

  function addFormToDrawer(form, submitter) {
    if (!isCartAddForm(form) || form.dataset.mdsSubmitting === 'true') return;

    setSubmitting(form, submitter, true);

    var cart = cartDrawer();
    var formData = new FormData(form);
    requestSections(cart, formData);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'Unable to add this item.');
          }
          return payload;
        });
      })
      .then(function (response) {
        renderDrawer(cart, response, submitter);
        document.dispatchEvent(new CustomEvent('mds:cart-added', { detail: response }));
      })
      .catch(function (error) {
        console.error('[Maison de Soin cart]', error);
        document.dispatchEvent(new CustomEvent('mds:cart-error', { detail: error }));
      })
      .then(function () {
        setSubmitting(form, submitter, false);
      });
  }

  window.addEventListener(
    'click',
    function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var cartLink = event.target.closest('#cart-icon-bubble');
      if (cartLink) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer(cartDrawer(), cartLink);
        return;
      }

      // The fixed purchase bar lives outside the product form and associates
      // with it through the HTML `form` attribute. Resolve that relationship
      // explicitly before any generic submitter logic so the browser can never
      // fall through to a document navigation when this external submit button
      // is used.
      var stickySubmitter = event.target.closest('#mds-sch-cta');
      if (stickySubmitter) {
        var stickyFormId = stickySubmitter.getAttribute('form');
        var stickyForm = stickyFormId ? document.getElementById(stickyFormId) : null;
        if (!stickyForm) stickyForm = document.querySelector('.mds-fp__bundles-form');
        if (!isCartAddForm(stickyForm)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        addFormToDrawer(stickyForm, stickySubmitter);
        return;
      }

      var submitter = event.target.closest('button, input[type="submit"]');
      if (!submitter || submitter.type !== 'submit') return;

      var form = submitter.form || submitter.closest('form');
      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addFormToDrawer(form, submitter);
    },
    true
  );

  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addFormToDrawer(
        form,
        event.submitter || form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]')
      );
    },
    true
  );

  window.mdsCartDrawerAdd = addFormToDrawer;
  document.documentElement.setAttribute('data-mds-cart-drawer-controller', 'ready');
})();
